import { useQuery } from '@tanstack/react-query'

import { getAllBundles } from '@flecto/api/saas'

export function useQueryGetAllBundles(
) {
  const CACHE_DURATION = 1000 * 60 * 2 // 2 minutes

  return useQuery({
    queryKey: ['QueryGetAllBundles'],
    queryFn: async () => await getAllBundles(),
    staleTime: CACHE_DURATION,
  })
}
